import { render, staticRenderFns } from "./customCategory.vue?vue&type=template&id=39f0811a&scoped=true"
import script from "./customCategory.vue?vue&type=script&lang=js"
export * from "./customCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f0811a",
  null
  
)

export default component.exports